/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown> }} Prescription_Reason_Goal_MetInputs */

const en_us2_prescription_reason_goal_met = /** @type {(inputs: Prescription_Reason_Goal_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Burns more for ${i?.muscle}, good for recomposition`)
};

const pt_br2_prescription_reason_goal_met = /** @type {(inputs: Prescription_Reason_Goal_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gasta mais para ${i?.muscle}: bom para recomposição`)
};

const es_419_prescription_reason_goal_met = /** @type {(inputs: Prescription_Reason_Goal_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quema más para ${i?.muscle}: bueno para la recomposición`)
};

const pt_pt2_prescription_reason_goal_met = /** @type {(inputs: Prescription_Reason_Goal_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gasta mais para ${i?.muscle}: bom para recomposição`)
};

const fr_fr2_prescription_reason_goal_met = /** @type {(inputs: Prescription_Reason_Goal_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dépense plus pour ${i?.muscle} : idéal pour la recomposition`)
};

const de_de2_prescription_reason_goal_met = /** @type {(inputs: Prescription_Reason_Goal_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verbraucht mehr für ${i?.muscle}, gut für die Rekomposition`)
};

const it_it2_prescription_reason_goal_met = /** @type {(inputs: Prescription_Reason_Goal_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Consuma di più per ${i?.muscle}, utile per la ricomposizione`)
};

/**
* | output |
* | --- |
* | "Burns more for {muscle}, good for recomposition" |
*
* @param {Prescription_Reason_Goal_MetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_goal_met = /** @type {((inputs: Prescription_Reason_Goal_MetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_Goal_MetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_goal_met(inputs)
	if (locale === "es-419") return es_419_prescription_reason_goal_met(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_goal_met(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_goal_met(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_goal_met(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_goal_met(inputs)
	return en_us2_prescription_reason_goal_met(inputs)
});
export { prescription_reason_goal_met as "prescription.reason.goal_met" }